<div
  class="kpi-card"
  [class.kpi-card--compact]="compact"
  [class.kpi-card--loading]="loading"
>
  <!-- Icon -->
  <div class="kpi-card__icon" [ngClass]="iconColorClass">
    <i class="pi" [ngClass]="icon"></i>
  </div>

  <!-- Content -->
  <div class="kpi-card__content">
    <!-- Title -->
    <span class="kpi-card__title">{{ title }}</span>

    <!-- Value -->
    <div class="kpi-card__value-row">
      <span class="kpi-card__value" [class.kpi-card__value--loading]="loading">
        {{ formattedValue }}
      </span>

      <!-- Trend Badge -->
      @if (trend !== null && !loading) {
        <span
          class="kpi-card__trend"
          [ngClass]="'kpi-card__trend--' + trendClass"
        >
          <i class="pi" [ngClass]="trendIcon"></i>
          <span>{{ trendValue | number: "1.1-1" }}%</span>
        </span>
      }
    </div>

    <!-- Comparison label -->
    @if (previousValue !== null && !loading && !compact) {
      <span class="kpi-card__comparison">
        {{
          "STATISTICS.KPI.VS_PREVIOUS"
            | translate: { value: (previousValue | number: "1.0-0") }
        }}
      </span>
    }
  </div>
</div>
